/** LiveHelp100 在线客服（与全站客服入口一致） */
export const LIVEHELP100_SUPPORT_URL =
  "https://j5wxcf.7mmon3ss.com/chatwindow.aspx?siteId=65001365&planId=e146e265-fd7b-4e13-a3d3-76908e2394b3";

export function openLivehelp100Support(): void {
  if (typeof window === "undefined") return;
  window.open(LIVEHELP100_SUPPORT_URL, "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
}
